import { render, staticRenderFns } from "./BannerDialog.vue?vue&type=template&id=70f837a2&scoped=true&"
import script from "./BannerDialog.vue?vue&type=script&lang=js&"
export * from "./BannerDialog.vue?vue&type=script&lang=js&"
import style0 from "./BannerDialog.vue?vue&type=style&index=0&id=70f837a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f837a2",
  null
  
)

export default component.exports